module.exports = {"430482001":"宜阳街道","430482002":"泉峰街道","430482003":"培元街道","430482006":"天堂山","430482101":"柏坊镇","430482102":"水口山镇","430482103":"烟洲镇","430482104":"荫田镇","430482105":"白沙镇","430482106":"西岭镇","430482108":"三角塘镇","430482109":"洋泉镇","430482110":"庙前镇","430482111":"罗桥镇","430482112":"板桥镇","430482113":"胜桥镇","430482114":"官岭镇","430482115":"新河镇","430482201":"蓬塘乡","430482202":"兰江乡","430482203":"大堡乡","430482206":"塔山瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430482.json
// module id = 1686
// module chunks = 0